<template>
    <div class="doctor-recommendation">
        <p class="panel-title">Top10 医生推荐</p>
        <el-tabs v-model="activeDoctor">
            <el-tab-pane v-for="(doctor, index) in doctors" :key="index" :label="doctor.name" :name="String(index)" />
        </el-tabs>
        <div v-if="selectedDoctor && selectedDoctor.result.nodes.length" class="graph-card">
            <p class="panel-title">{{ selectedDoctor.name }}知识图谱</p>
            <knowledge-graph :key="activeDoctor" :graph-data="selectedDoctor.result" :title="selectedDoctor.name + '知识图谱'" height="420px" />
        </div>
    </div>
</template>
<script>
import KnowledgeGraph from './knowledge_graph.vue';
export default {
    name: 'DoctorRecommendation',
    components: { KnowledgeGraph },
    props: { doctors: { type: Array, default: () => [] } },
    data() { return { activeDoctor: '0' }; },
    computed: { selectedDoctor() { return this.doctors[Number(this.activeDoctor)]; } },
    watch: { doctors() { this.activeDoctor = '0'; } },
};
</script>
<style lang="less" scoped>
.panel-title { margin: 0 0 12px; font-size: 14px; font-weight: bold; color: #0C55AA; line-height: 20px; }
.graph-card { padding: 14px; background: #fff; border: 1px solid #E8EEF8; border-radius: 10px; }
</style>
